import React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";


const OverlayModal = ({ open, onClose, children }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={10}
    PaperProps={{
      sx: {
        background: 'transparent',
        boxShadow: 'none',
        overflow: 'visible',
        p: 0,
      }
    }}
    BackdropProps={{
      sx: {
        backgroundColor: 'rgba(0,0,0,0.25)'
      }
    }}
  >
    {children}
  </Dialog>
);

export default OverlayModal;
